export const TestRideFaildIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 2C13.0836 2.00331 10.2877 3.1633 8.22548 5.22548C6.1633 7.28766 5.00331 10.0836 5 13C5 16.925 6.81375 21.085 10.25 25.0312C11.794 26.8145 13.5318 28.4202 15.4313 29.8187C15.5994 29.9365 15.7997 29.9997 16.005 29.9997C16.2103 29.9997 16.4106 29.9365 16.5788 29.8187C18.4747 28.4196 20.2091 26.8139 21.75 25.0312C25.1813 21.085 27 16.925 27 13C26.9967 10.0836 25.8367 7.28766 23.7745 5.22548C21.7123 3.1633 18.9164 2.00331 16 2ZM16 27.75C13.9338 26.125 7 20.1562 7 13C7 10.6131 7.94821 8.32387 9.63604 6.63604C11.3239 4.94821 13.6131 4 16 4C18.3869 4 20.6761 4.94821 22.364 6.63604C24.0518 8.32387 25 10.6131 25 13C25 20.1537 18.0663 26.125 16 27.75Z"
        fill="#272D3B"
      />
      <path
        d="M16.0968 29.3537C21.7808 28.9477 27.6549 27.9672 27.933 26.513C28.0872 25.7062 27.725 24.2801 21.7781 23.1989M10.4154 23.6723C8.04818 24.1458 2.93495 23.9564 1.41992 19.4113"
        stroke="#272D3B"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-dasharray="2 2"
      />
      <path
        d="M17.285 7.89154L17.0412 18.2628H14.7538L14.5038 7.89154H17.285ZM15.8975 22.8915C15.485 22.8915 15.1309 22.7228 14.835 22.3853C14.5392 22.0429 14.3934 21.6331 14.3975 21.1558C14.3934 20.6833 14.5392 20.2782 14.835 19.9407C15.1309 19.6032 15.485 19.4345 15.8975 19.4345C16.2933 19.4345 16.6412 19.6032 16.9412 19.9407C17.2412 20.2782 17.3933 20.6833 17.3975 21.1558C17.3933 21.474 17.3204 21.7657 17.1787 22.0309C17.0412 22.2913 16.86 22.501 16.635 22.6601C16.41 22.8144 16.1642 22.8915 15.8975 22.8915Z"
        fill="#272D3B"
      />
    </svg>
  );
};
